export const mainProductConfig = {
  'website-wfs': {
    MainName: 'Weekly Financial Solution',
    MainProduct: 'Weekly Financial Solution',
    MainProductHyphen: 'Weekly-Financial-Solution',
    PublicURL: 'https://learn.weeklyfinancialsolutions.com/',
    SocialMediaLinks: ['https://www.facebook.com/weeklyfinancialsolutions/'],
    LogoURL:
      'https://d9hhrg4mnvzow.cloudfront.net/learn.weeklyfinancialsolutions.com/open-program-fdr/a74f9794-wfs-logo-dark_106u02f000000000000028.png',
    FooterLogo: '/wfs-logo-dark.png',
    HeaderLogo: 'wfs-logo-dark',
    URL: 'Weeklyfinancialsolutions.com',
    headerCta: false,
    showSignIn: false,
    showPhone: false,
    showNavFooter: false,
  },
  'website-fdr': {
    MainName: 'Freedom Debt Relief',
    MainProduct: 'Freedom Debt Relief',
    MainProductHyphen: 'freedom-debt-relief',
    PublicURL: 'https://www.freedomdebtrelief.com',
    SocialMediaLinks: [
      'https://x.com/FreedomDebt',
      'https://www.facebook.com/pages/Freedom-Debt-Relief/69869352985',
      'https://www.youtube.com/freedomdebtrelief',
      'https://www.linkedin.com/company/freedom-debt-relief',
      'https://www.instagram.com/achievecom',
    ],
    LogoURL: 'https://www.freedomdebtrelief.com/multi-site-assets/icons/fdr-logo.svg',
    FooterLogo: '/fdr-logo.svg',
    HeaderLogo: 'fdr-logo.svg',
    URL: 'Freedomdebtrelief.com',
    headerCta: false,
    showSignIn: false,
    showPhone: false,
    showNavFooter: true,
  },
  achieve: {
    MainName: 'Achieve',
    MainProduct: 'Achieve Web',
    MainProductHyphen: 'Achieve-Web',
    PublicURL: 'https://www.achieve.com',
    SocialMediaLinks: [
      'https://twitter.com/achievecom',
      'https://www.facebook.com/achievecom',
      'https://www.youtube.com/@Achievecom',
      'https://www.linkedin.com/company/achievecareers',
      'https://www.tiktok.com/@achievecom_',
      'https://www.instagram.com/achievecom',
    ],
    LogoURL: 'https://www.achieve.com/2026_Achieve_Logo_RGB.svg?w=3840',
    FooterLogo: '/2026_Achieve_Logo_footer.svg',
    HeaderLogo: '2026_Achieve_Logo_RGB',
    URL: 'Achieve.com',
    headerCta: true,
    showSignIn: true,
    showPhone: true,
    showNavFooter: true,
  },
  'website-ffn': {
    MainName: 'Freedom Financial Network',
    MainProduct: 'Freedom Financial Network',
    MainProductHyphen: 'freedom-financial-network',
    PublicURL: 'https://www.freedomfinancialnetwork.com',
    SocialMediaLinks: [
      'https://twitter.com/achievecom',
      'https://www.facebook.com/achievecom',
      'https://www.youtube.com/@Achievecom',
      'https://www.linkedin.com/company/achievecareers',
      'https://www.tiktok.com/@achievecom_',
      'https://www.instagram.com/achievecom',
    ],
    LogoURL: 'https://www.achieve.com/2026_Achieve_Logo_RGB.svg?w=3840',
    FooterLogo: '/2026_Achieve_Logo_RGB.svg',
    HeaderLogo: '2026_Achieve_Logo_RGB',
    URL: 'Achieve.com',
    headerCta: true,
    showSignIn: true,
    showPhone: true,
    showNavFooter: true,
  },
  'website-bills': {
    MainName: 'Bills',
    MainProduct: 'Bills',
    MainProductHyphen: 'bills',
    PublicURL: 'https://www.bills.com',
    SocialMediaLinks: [],
    LogoURL: 'https://www.bills.com/multi-site-assets/icons/bills-logo.svg',
    FooterLogo: '/bills-logo.svg',
    HeaderLogo: 'bills-logo.svg',
    URL: 'Bills.com',
    headerCta: false,
    showSignIn: false,
    showPhone: false,
    showNavFooter: true,
  },
}
